import { DestroyRef, Directive, ElementRef, inject, OnInit, Renderer2 } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { createExternalLinkIcon } from '@core/utils/create-external-link-icon';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  selector: '[appExternalLink]'
})
export class ExternalLink implements OnInit {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private readonly translate = inject(TranslateService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit() {
    const icon = createExternalLinkIcon('');
    this.renderer.appendChild(this.el.nativeElement, icon);
    this.translate
      .stream('ARIA-LABELS.OPENS-IN-NEW-TAB')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((label: string) => {
        icon.querySelector('.cdk-visually-hidden')!.textContent = ` ${label}`;
      });
  }
}
